if (!customElements.get('recipient-form')) {
    customElements.define(
      'recipient-form',
      class RecipientForm extends HTMLElement {
        constructor() {
          super();
          this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
          this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
          this.checkboxInput.disabled = false;
          this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
          this.hiddenControlField.disabled = true;
          this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
          this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
          this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
          this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
          this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
          if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();
  
          this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
          this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
          this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
          this.defaultErrorHeader = this.errorMessage?.innerText;
          this.currentProductVariantId = this.dataset.productVariantId;
          this.addEventListener('change', this.onChange.bind(this));
          
          // Add form submission listener to ensure fields are enabled
          const productForm = this.closest('form');
          console.log('Looking for form, found:', productForm);
          if (productForm) {
            // Add multiple event listeners to catch different submission methods
            productForm.addEventListener('submit', this.enableFieldsForSubmission.bind(this));
            productForm.addEventListener('submit', (e) => {
              setTimeout(() => {
                this.logFormData();
              }, 100);
            });
            
            // Also listen for click events on submit buttons
            const submitButtons = productForm.querySelectorAll('button[type="submit"], input[type="submit"]');
            submitButtons.forEach(button => {
              button.addEventListener('click', this.enableFieldsForSubmission.bind(this));
              // Add mousedown event as well to catch it even earlier
              button.addEventListener('mousedown', this.enableFieldsForSubmission.bind(this));
            });
            
            // Override any potential form submission handlers
            const originalSubmit = productForm.submit;
            productForm.submit = () => {
              this.enableFieldsForSubmission();
              originalSubmit.call(productForm);
            };
            
            console.log('Recipient form initialized for form:', productForm.id);
            console.log('Found submit buttons:', submitButtons.length);
            console.log('Form action:', productForm.action);
            console.log('Form method:', productForm.method);
          }
          
          this.onChange();
          
          // Add a periodic check to ensure fields are enabled when needed
          this.startPeriodicCheck();
          
          // Intercept AJAX requests
          this.interceptAjaxRequests();
        }
  
        cartUpdateUnsubscriber = undefined;
        variantChangeUnsubscriber = undefined;
        cartErrorUnsubscriber = undefined;
  
        connectedCallback() {
          // Only use pub/sub if available
          if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
              if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
                this.resetRecipientForm();
              }
            });

            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              if (event.data.sectionId === this.dataset.sectionId) {
                this.currentProductVariantId = event.data.variant.id.toString();
              }
            });

            this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
              if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
                this.displayErrorMessage(event.message, event.errors);
              }
            });
          } else {
            console.log('Pub/sub system not available, recipient form will work without it');
          }
        }
  
        disconnectedCallback() {
          if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
          }

          if (this.variantChangeUnsubscriber) {
            this.variantChangeUnsubscriber();
          }

          if (this.cartErrorUnsubscriber) {
            this.cartErrorUnsubscriber();
          }

          this.stopPeriodicCheck();
        }
  
        onChange() {
          console.log('Recipient form onChange triggered, checkbox checked:', this.checkboxInput.checked);
          if (this.checkboxInput.checked) {
            this.enableInputFields();
            this.hiddenControlField.disabled = false;
            this.recipientFieldsLiveRegion.innerText = 'Recipient form expanded';
            console.log('Recipient form enabled, hidden control field disabled:', this.hiddenControlField.disabled);
          } else {
            this.clearInputFields();
            this.disableInputFields();
            this.hiddenControlField.disabled = true;
            this.clearErrorMessage();
            this.recipientFieldsLiveRegion.innerText = 'Recipient form collapsed';
            console.log('Recipient form disabled');
          }
        }
  
        inputFields() {
          return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
        }
  
        disableableFields() {
          return [...this.inputFields(), this.offsetProperty];
        }
  
        clearInputFields() {
          this.inputFields().forEach((field) => (field.value = ''));
        }
  
        enableInputFields() {
          this.disableableFields().forEach((field) => {
            field.disabled = false;
            // Also remove any disabled attribute that might be set by other scripts
            field.removeAttribute('disabled');
          });
        }
  
        disableInputFields() {
          this.disableableFields().forEach((field) => (field.disabled = true));
        }
  
        displayErrorMessage(title, body) {
          this.clearErrorMessage();
          this.errorMessageWrapper.hidden = false;
          if (typeof body === 'object') {
            this.errorMessage.innerText = this.defaultErrorHeader;
            return Object.entries(body).forEach(([key, value]) => {
              const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
              const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
              const message = `${value.join(', ')}`;
              const errorMessageElement = this.querySelector(`#${errorMessageId}`);
              const errorTextElement = errorMessageElement?.querySelector('.error-message');
              if (!errorTextElement) return;
  
              if (this.errorMessageList) {
                this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
              }
  
              errorTextElement.innerText = `${message}.`;
              errorMessageElement.classList.remove('hidden');
  
              const inputElement = this[`${key}Input`];
              if (!inputElement) return;
  
              inputElement.setAttribute('aria-invalid', true);
              inputElement.setAttribute('aria-describedby', errorMessageId);
            });
          }
  
          this.errorMessage.innerText = body;
        }
  
        createErrorListItem(target, message) {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.setAttribute('href', target);
          a.innerText = message;
          li.appendChild(a);
          li.className = 'error-message';
          return li;
        }
  
        clearErrorMessage() {
          this.errorMessageWrapper.hidden = true;
  
          if (this.errorMessageList) this.errorMessageList.innerHTML = '';
  
          this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
            field.classList.add('hidden');
            const textField = field.querySelector('.error-message');
            if (textField) textField.innerText = '';
          });
  
          [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
            inputElement.setAttribute('aria-invalid', false);
            inputElement.removeAttribute('aria-describedby');
          });
        }
  
        resetRecipientForm() {
          if (this.checkboxInput.checked) {
            this.checkboxInput.checked = false;
            this.clearInputFields();
            this.clearErrorMessage();
          }
        }

        // Ensure form fields are enabled before submission
        enableFieldsForSubmission() {
          console.log('Form submission detected, checkbox checked:', this.checkboxInput.checked);
          if (this.checkboxInput.checked) {
            this.enableInputFields();
            this.hiddenControlField.disabled = false;
            console.log('Recipient form fields enabled for submission');
            console.log('Email:', this.emailInput.value);
            console.log('Name:', this.nameInput.value);
            console.log('Message:', this.messageInput.value);
            console.log('Send on:', this.sendonInput.value);
            console.log('Hidden control field enabled:', !this.hiddenControlField.disabled);
            console.log('Hidden control field name:', this.hiddenControlField.name);
            console.log('Hidden control field value:', this.hiddenControlField.value);
            
            // Log all form fields to see their state
            this.inputFields().forEach(field => {
              console.log(`Field ${field.name}: value="${field.value}", disabled=${field.disabled}`);
            });
          } else {
            console.log('Checkbox not checked, recipient form not submitted');
          }
        }

        // Log form data to debug submission
        logFormData() {
          const productForm = this.closest('form');
          if (productForm) {
            const formData = new FormData(productForm);
            console.log('=== FORM DATA DEBUG ===');
            for (let [key, value] of formData.entries()) {
              if (key.includes('properties') || key.includes('__shopify')) {
                console.log(`${key}: ${value}`);
              }
            }
            console.log('=== END FORM DATA DEBUG ===');
          }
        }

        // Start periodic check to ensure fields are enabled
        startPeriodicCheck() {
          this.checkInterval = setInterval(() => {
            if (this.checkboxInput.checked) {
              // Ensure all fields are enabled when checkbox is checked
              this.enableInputFields();
              this.hiddenControlField.disabled = false;
              
              // Also check if any fields got disabled by other scripts
              const disabledFields = this.disableableFields().filter(field => field.disabled);
              if (disabledFields.length > 0) {
                console.log('Found disabled fields, re-enabling:', disabledFields.map(f => f.name));
                this.enableInputFields();
                this.hiddenControlField.disabled = false;
              }
            }
          }, 50); // Check every 50ms for more aggressive monitoring
        }

        // Stop periodic check
        stopPeriodicCheck() {
          if (this.checkInterval) {
            clearInterval(this.checkInterval);
          }
        }

        // Intercept AJAX requests to ensure fields are enabled
        interceptAjaxRequests() {
          const self = this; // Store reference to the recipient form
          
          // Intercept fetch requests
          const originalFetch = window.fetch;
          window.fetch = (...args) => {
            if (self.checkboxInput.checked) {
              self.enableFieldsForSubmission();
              console.log('Intercepted fetch request, ensuring fields are enabled');
            }
            return originalFetch.apply(this, args);
          };

          // Intercept XMLHttpRequest
          const originalXHROpen = XMLHttpRequest.prototype.open;
          XMLHttpRequest.prototype.open = function(method, url, ...args) {
            if (url && (url.includes('/cart/add') || url.includes('/cart/update'))) {
              console.log('Intercepted XHR request to cart:', url);
              // Store reference to this request
              this._isCartRequest = true;
            }
            return originalXHROpen.apply(this, [method, url, ...args]);
          };

          const originalXHRSend = XMLHttpRequest.prototype.send;
          XMLHttpRequest.prototype.send = function(data) {
            if (this._isCartRequest && self.checkboxInput.checked) {
              self.enableFieldsForSubmission();
              console.log('Intercepted XHR send, ensuring fields are enabled');
              
              // Modify the data to include recipient form fields
              if (data instanceof FormData) {
                // Add recipient form data to the FormData
                self.addRecipientDataToFormData(data);
                console.log('Added recipient data to FormData');
              } else if (typeof data === 'string') {
                // Parse URL-encoded data and add recipient fields
                const modifiedData = self.addRecipientDataToString(data);
                console.log('Modified string data with recipient fields');
                return originalXHRSend.apply(this, [modifiedData]);
              }
            }
            return originalXHRSend.apply(this, [data]);
          };
        }

        // Add recipient data to FormData
        addRecipientDataToFormData(formData) {
          if (this.emailInput.value) {
            formData.set('properties[Recipient email]', this.emailInput.value);
          }
          if (this.nameInput.value) {
            formData.set('properties[Recipient name]', this.nameInput.value);
          }
          if (this.messageInput.value) {
            formData.set('properties[Message]', this.messageInput.value);
          }
          if (this.sendonInput.value) {
            formData.set('properties[Send on]', this.sendonInput.value);
          }
          formData.set('properties[__shopify_send_gift_card_to_recipient]', 'if_present');
          if (this.offsetProperty) {
            formData.set('properties[__shopify_offset]', this.offsetProperty.value);
          }
        }

        // Add recipient data to URL-encoded string
        addRecipientDataToString(dataString) {
          const params = new URLSearchParams(dataString);
          
          if (this.emailInput.value) {
            params.set('properties[Recipient email]', this.emailInput.value);
          }
          if (this.nameInput.value) {
            params.set('properties[Recipient name]', this.nameInput.value);
          }
          if (this.messageInput.value) {
            params.set('properties[Message]', this.messageInput.value);
          }
          if (this.sendonInput.value) {
            params.set('properties[Send on]', this.sendonInput.value);
          }
          params.set('properties[__shopify_send_gift_card_to_recipient]', 'if_present');
          if (this.offsetProperty) {
            params.set('properties[__shopify_offset]', this.offsetProperty.value);
          }
          
          return params.toString();
        }
      }
    );
  }
  